<template>
  <v-row class="custom-pagination mt-6">
    <v-pagination
      class="ma-auto"
      :length="props.tableModel.bind.pageCount"
      :model-value.sync="props.tableModel.bind.options.page"
      @update:model-value="(pageSize) => onUpdatePage(pageSize)"
      rounded
    />
    <div class="custom-pagination-select" v-if="showPageSizeSelect">
      <span>{{ $t('На странице по:') }}</span>
      <v-select
        variant='plain'
        class="custom-pagination-select-box"
        :items="props.pageSizesList"
        :model-value="props.tableModel.bind.itemsPerPage"
        @update:model-value="(pageSize) => onUpdateItemsPerPage(pageSize)"
        hide-details
        menu-icon
      />
    </div>
  </v-row>
</template>

<script setup lang="ts">
const props = defineProps({
  tableModel: {
    type: Object,
    required: true,
  },
  pageSizesList: {
    type: Object,
  },
  showPageSizeSelect: {
    type: Boolean,
    default: true,
  },
});

const onUpdateItemsPerPage = (value) => {
  props.tableModel.bind.itemsPerPage = parseInt(value, 10);
  props.tableModel.bind.options.itemsPerPage = parseInt(value, 10);
  props.tableModel.bind.options.page = 1;
  props.tableModel.reload();
};

const onUpdatePage = (value) => {
  props.tableModel.bind.options.page = parseInt(value, 10);
  props.tableModel.reload();
};
</script>

<style scoped lang="scss">
.custom-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;

  font-family: 'Abrade';
  font-weight: 500;
  font-size: 16px;

  &-select {
    display: flex;
    align-items: center;
    gap: 10px;

    &-box {
      font-weight: 500;
      background-color: rgb(var(--white-color));
      border: 1px solid rgb(var(--grey-border-color));
      border-radius: 8px;
    }
  }
  
  :deep(.v-field__input) {
    display: block;
    padding: 0;
    width: 48px;
    height: 36px;
    min-height: 0;
    text-align: center;
    align-content: center;
  }
}
</style>